<template>
  <form 
    v-if="!requestSuccess" 
    class="animated fadeIn" 
    @submit.prevent="submit()">
    <h1>Reset Password</h1>
    <hr >
    <!-- <p class="text-muted">Create your new password.</p> -->
    <div class="form-group mb-3">
      <label for="newPassword">New Password</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="icon-lock"/></span>
        </div>
        <input 
          id="newPassword" 
          v-model="passwordModel.newPass" 
          type="password" 
          class="form-control" 
          placeholder="New Password" 
          required>
      </div>
    </div>
    <div class="form-group mb-3">
      <label for="newPasswordConfirm">Confirm New Password</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text"><i class="icon-lock"/></span>
        </div>
        <input 
          id="newPasswordConfirm" 
          v-model="passwordModel.newPassConfirm" 
          type="password" 
          class="form-control" 
          placeholder="Confirm Password" 
          required>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col">
        <small 
          v-show="isError" 
          class="text-danger">{{ msg.errorMsg }}</small>
        <small 
          v-show="requestSuccess" 
          class="text-success">{{ msg.successMsg }}</small>
      </div>
    </div>
    <div class="row">
      <div 
        v-show="!requestSuccess" 
        class="col">
        <button 
          :disabled="isFetching" 
          type="submit" 
          class="btn btn-primary px-4">Submit</button>
      </div>
    </div>
  </form>
  <div 
    v-else-if="requestSuccess" 
    class="success-img text-center text-success px-3 py-3 my-4">
    <i class="fa fa-check-circle-o fa-4x" />
    <h5 class="mt-2">{{ msg.successMsg }}</h5>
  </div>
</template>

<script>
import auth from '@/services/auth.service'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      passwordModel: Object,
      msg: Object,
      isFetching: false,
      isError: false,
      requestSuccess: false,
      fpToken: ''
    }
  },
  mounted () {
    this.fpToken = this.$route.query.hash
    this.fpToken = this.fpToken.replace(/ /g, '+')
    this.passwordModel.username = this.$route.query.user
  },
  methods: {
    submit () {
      if (this.passwordModel.newPass !== this.passwordModel.newPassConfirm) {
        this.isError = true;
        this.msg.errorMsg = 'New password and confirmation password do not match'
      } else {
        this.isFetching = true
        this.isError = false
        this.requestSuccess = false;
        auth.resetPassword(this.passwordModel, this.fpToken).then(
          (resp) => {
            this.isFetching = false
            this.requestSuccess = true
            this.msg.successMsg = resp.data.msgContent
          },
          (err) => {
            this.isFetching = false
            this.isError = true
            this.msg.errorMsg = err.response.data.msgContent
          }
        )
      }
    }
  },
}
</script>
